import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs'
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination';
import {
	Validator
} from 'vee-validate'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
import csvHelper from '../importjsontocsv';
export default {
	name: 'putawayreport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader,
		BasicSelect
	},
	data: function() {
		return {
			// totalRows:0,
			// currentPage: 0,
			//modalShow used for close the active/inactive modal(default)
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			listProductivityputawayData: [],
			listWarehouseData: [],
			listPutawayReportDataCsv: [],
			listuserdata: [],
			csvFields: [],
			datenow: '',
			// pageno: 0,
			// totalPage: 0,
			isLoading: false,
			searchFlag: false,
			loginwarehouseid: '',
			Warehouse_obj: '',
			username: '',
			transactionfromdate: '',
			transactiontodate: '',
			formattedDate: '',
			resultCount: '',
			listClientData: [],
			listuserData: [],
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			user_type: '',
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			limitExeed: false,
			recordLimit: 0,
			merchant: '',
			listMerchantIdData: [],
			item:{},
		    listMerchantData1:[],
		    merchantList:[]
		}
	},
	created: function() {},
	// when a page loads,mounted() will be call
	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		this.createdbyEmail = userdetail.email;
		this.reportname = this.$t('reports.productivityPutawayReportfilename');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantData();
		}
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getuserlist();
		  });
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantData();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				this.getuserlist();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

		this.time();
		this.getRecordLimit()
	},
	methods: {
		getMerchantData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem('selectedClient'),
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
                       this.item={
						   value:'',
						   text:''
					   };
						this.listMerchantData1=[{value:'',text: this.$t('common.selectMerchantPlaceHolder')}];
					    this.listMerchantData.forEach(ele=>{
						this.listMerchantData1.push({
							"value":ele.merchantid,
							"text":ele.merchantname
						})
					   })
					}
				}, error => {
					console.error(error)
				})
		},
		reset(){
			this.item={}
		},
		onSelect(item){
			this.item=item
			this.merchant=item.value
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRecordLimit',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getputawayreportDataForXls(3)

		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		time() {
			var self = this
			this.datenow = moment().format()
			setInterval(self.time, 1000)
		},

		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		getuserlist() {
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				return false;
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.user_type == 'system_user') {
				this.usertype = "system_user"
			}
			if (this.user_type == 'client_user') {
				this.usertype = "client_user"
			}
			if (this.user_type == 'warehouse_user') {
				this.usertype = "warehouse_user"
			}
			this.input = ({
				warehouseid: localStorage.getItem('selectedWarehouse'),
				utype: this.usertype
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'productivityReportUserList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listuserData = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchant = '';
		// 		this.getMerchantData();
		// 		if (this.warehouseid) {
		// 			this.getuserlist();

		// 		}

		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			// this.getputawayreportData();
		// 		}
		// 	}
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.getputawayreportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getputawayreportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getputawayreportData(2);
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},

		//to get Stock list
		getputawayreportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var putawayto_date = '';
			var putawayfr_date = '';
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			var dataFilter = {};
			// this.ClientErr = '';
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.totalPage = 0;
				this.listProductivityputawayData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.totalPage = 0;
				this.listProductivityputawayData = [];
				return false;
			}
			this.isLoading = true;
			if (this.transactionfromdate) {
				putawayfr_date = this.dateFormat1(this.transactionfromdate)
			}

			if (this.transactiontodate == '') {
				putawayto_date = '';
			} else {
				putawayto_date = this.dateFormat2(this.transactiontodate)
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				fromdate: putawayfr_date,
				todate: putawayto_date,
				user: this.username,
				csvData: csvCheck,
				clientid: localStorage.getItem('selectedClient'),
				warehouseid: localStorage.getItem('selectedWarehouse'),
				merchantid: this.merchant
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'productivityReportForPutAway',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
						if (csvCheck == 1) {
							this.show = true;
							this.download = false;
							this.csvFields = {
								'createdby': this.$t('common.userName'),
								'merchantname':this.$t('common.merchantName'),
								'putawaycreateddate': this.$t('productivityReport.transactionDate'),
								'totalsku': this.$t('reports.totalSKUreceived'),
								'totalcancelqty': this.$t('reports.totalCancelQty'),
								'totalputaway': this.$t('reports.totalputaway'),
								'totalrejectedqty': this.$t('reports.totalRejectedQty'),
								'totalracks': this.$t('reports.totalracksusedforputaway'),
							};
							var dateFilter = ['CreatedDate', 'transactiontodate', 'transactionfromdate'];
							var skipFilter = ['transcationdate'];
							this.listPutawayReportDataCsv = result.data.data;
							// this.jsonToCSV('putawayreport', this.listPutawayReportDataCsv, this.csvFields, dateFilder, skipFilter);
							csvHelper.data.jsonToCSV(this.$t('reports.productivityPutawayReportfilename'), this.listPutawayReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

						} else {
							this.listProductivityputawayData = result.data.data;
							if (result.data.errorCode == -1) {
								this.resultCount = 0
							} else {
								this.totalRows = result.data.count;
								if (Number(this.totalRows) > Number(this.recordLimit)) {
									this.limitExeed = true
								}
								this.resultCount = result.data.count
								if (this.totalRows < 10) {
									this.totalPage = 1
								} else {
									this.totalPage = Math.ceil(this.totalRows / 10)
								}
							}
						}
						this.isLoading = false;
					},
					error => {
						console.error(error)
					})

		},
		getputawayreportDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var putawayto_date = '';
			var putawayfr_date = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			// this.ClientErr = '';


			if (this.transactionfromdate) {
				putawayfr_date = this.dateFormat1(this.transactionfromdate)
			}

			if (this.transactiontodate == '') {
				putawayto_date = '';
			} else {
				putawayto_date = this.dateFormat2(this.transactiontodate)
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				fromdate: putawayfr_date,
				todate: putawayto_date,
				user: this.username,
				csvData: csvCheck,
				clientid: localStorage.getItem('selectedClient'),
				warehouseid: localStorage.getItem('selectedWarehouse'),
				merchantid: this.merchant
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'productivityReportForPutAway',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
						if (csvCheck == 3) {
							if (result.data.data.length > 0) {
								this.listReportDataforxls = [];
								this.csvFieldsForXls[this.$t('common.userName')] = 'createdby';
								this.csvFieldsForXls[this.$t('common.merchantName')] = 'merchantname';
								this.csvFieldsForXls[this.$t('productivityReport.transactionDate')] = 'putawaycreateddate';
								this.csvFieldsForXls[this.$t('reports.totalSKUreceived')] = 'totalsku';
								this.csvFieldsForXls[this.$t('reports.totalCancelQty')] = 'totalcancelqty';
								this.csvFieldsForXls[this.$t('reports.totalputaway')] = 'totalputaway';
								this.csvFieldsForXls[this.$t('reports.totalRejectedQty')] = 'totalrejectedqty';
								this.csvFieldsForXls[this.$t('reports.totalracksusedforputaway')] = 'totalracks';

								this.listReportDataforxls = result.data.data;
							} else {
								if (result.data.status == true) {
									this.$alertify.success(this.$t('common.reportSizeError'));
								} else {
									this.$alertify.error(result.data.msg.message);
								}
							}


						}


					},
					error => {
						console.error(error)
					})

		},
		//to reset search form
		resetForm() {
			this.show = false;
			this.download = true;
			this.username = '';
			this.transactionfromdate = '';
			this.transactiontodate = '';
			this.listProductivityputawayData = [];
			this.pageno = this.totalPage = 0;
			this.searchFlag = false;
			this.totalRows = 0;
			this.merchant='';
			this.item={}
			// this.getputawayreportData();
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},

		//to paginate  GRC List
		// getPaginationData(currentPage) {
		//   this.pageno = (currentPage - 1) * 10
		//   this.getputawayreportData()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getputawayreportData()
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/productivity report/productivityputawayreport/productivityputawayreport.component.js